import { useTranslation } from 'i18n';
import { Typography } from 'ui';

import { getCreateSiteMaterialUrl } from '../../utils/getCreateSiteMaterialUrl';

type Props = {
  tradeCompanyId?: number;
};

export const NoSiteMaterialsOption = ({ tradeCompanyId }: Props) => {
  const { t } = useTranslation('orders');

  if (tradeCompanyId) {
    return (
      <Typography>
        {t('siteMaterials.noSiteMaterialsOption.noSiteMaterialFound')}{' '}
        <a target="_blank" href={getCreateSiteMaterialUrl(tradeCompanyId)} rel="noreferrer">
          {t('siteMaterials.noSiteMaterialsOption.createSiteMaterial')}
        </a>
      </Typography>
    );
  }
  return <Typography>{t('siteMaterials.noSiteMaterialsOption.noSiteMaterialFound')}</Typography>;
};
